// @ vendors
const Immutable = require('immutable');

// @ constants
const {
    INSURANCE_REQUEST_STATE_REQUEST,
    INSURANCE_REQUEST_STATE_SUCCESS,
    INSURANCE_REQUEST_STATE_FAILURE,
    INSURANCE_REQUEST_RECOMMENDATION_REQUEST,
    INSURANCE_REQUEST_RECOMMENDATION_SUCCESS,
    INSURANCE_REQUEST_RECOMMENDATION_FAILURE
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => Immutable.fromJS({
    data: null,
    recommendation: [],
    isFetching: false,
    hasFetched: false,
    isFetchingRecommendation: false,
    error: '',
    errorRecommendation: ''
});

const insuranceRequestState = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_STATE_REQUEST:
            return state.merge({
                isFetching: true,
                error: '',
                hasFetched: action.data.reset ? false : state.get('hasFetched'),
                data: action.data.reset ? null : state.get('data')
            });

        case INSURANCE_REQUEST_STATE_SUCCESS:
            return state.merge({
                data: action.data,
                hasFetched: true,
                isFetching: false
            });

        case INSURANCE_REQUEST_STATE_FAILURE:
            return state.merge({
                error: action.data.error,
                isFetching: false,
                hasFetched: true
            });

        case INSURANCE_REQUEST_RECOMMENDATION_REQUEST:
            return state.merge({
                isFetchingRecommendation: true,
                errorRecommendation: ''
            });

        case INSURANCE_REQUEST_RECOMMENDATION_SUCCESS:
            return state.merge({
                recommendation: action.data,
                isFetchingRecommendation: false
            });

        case INSURANCE_REQUEST_RECOMMENDATION_FAILURE:
            return state.merge({
                errorRecommendation: action.data.error,
                isFetchingRecommendation: false
            });

        default:
            return state
    }
};

module.exports = insuranceRequestState;
module.exports.setInitialState = setInitialState;
